import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {DbValidators} from "../../../../../shared/validators/DbValidators";
import {Config} from "../../../../../config/config";
import {Website} from "../../../../../websites/website/website";
import {OptionRegion} from "../../../../../shared/models/option-region.model";
import {CreateWebsiteHelpersService} from "../../../../../services/local/create-website-helpers.service";
import {IWebsiteInstallCloneForm} from "../../models/website-clone-data.model";
import {UserSubscription, UserSubscriptionCategory} from "../../../../../user/user-subscription";

@Component({
    selector: 'db-create-website-install-clone',
    templateUrl: './create-website-install-clone.component.html',
    styleUrls: ['./create-website-install-clone.component.scss'],
    standalone: false
})
export class CreateWebsiteInstallCloneComponent implements OnInit {

  @Input() loading = false;
  @Input() suggestedSubdomain = '';
  @Input() regions: OptionRegion[] = [];
  @Input() websites: Website[] = [];
  @Input() userSubscription: UserSubscription;
  @Input() configHostname: string;


  @Output() readonly submitted = new EventEmitter<IWebsiteInstallCloneForm>();
  @Output() readonly validationFailed = new EventEmitter<void>();

  public liveWebsites: Website[];
  public selectedWebsite: Website;
  public formSubmitted = false;
  public cloneWebsiteForm: FormGroup = new FormGroup({
    websiteId: new FormControl(null, Validators.required),
    region: new FormControl(null, Validators.required),
    subdomain: new FormControl('', [DbValidators.trim, Validators.required, Validators.pattern('^([a-z0-9]+(-[a-z0-9]+)*)$')]),
  });
  dataCenter: string;

  public get shouldShowHostnameTooltip(): boolean {
    return this.configHostname && this.configHostname.length > 13;
  }

  protected readonly UserSubscriptionCategory = UserSubscriptionCategory;

  constructor(
    private _createWebsiteHelpersService: CreateWebsiteHelpersService,
  ) { }

  ngOnInit() {
    this.liveWebsites = this.websites.filter(({type}) => type === 'live');
    this.suggestedSubdomain && this.cloneWebsiteForm.get('subdomain').setValue(this.suggestedSubdomain);
    this._setAvailableRegion();
  }

  private _setAvailableRegion(): void {
    const availableRegion = this.regions.find(({isAvailable}) => isAvailable);
    this.dataCenter = availableRegion && availableRegion.label;
    availableRegion && this.cloneWebsiteForm.get('region').setValue(availableRegion.value);
  }

  selectWebsite(websiteId: number): void {
    this.selectedWebsite = this.websites.find(({id}) => id === websiteId);
    this.cloneWebsiteForm.get('websiteId').setValue(websiteId);
  }

  public submit(): void {
    this.formSubmitted = true;
    if (this.cloneWebsiteForm.invalid) {
      return this.validationFailed.emit();
    }

    this._checkSubdomain();
  }

  private _checkSubdomain(): void {
    this._createWebsiteHelpersService.checkSubDomain(this.cloneWebsiteForm.value.subdomain)
      .then(response => {
        if (!response.success) {
          this.cloneWebsiteForm.get('subdomain').setErrors({taken: response.message});
          this.validationFailed.emit();
          return;
        }
        this._clone();
      });
  }

  private _clone(): void {
    const emittedData: IWebsiteInstallCloneForm = {
      ...this.cloneWebsiteForm.value, // Spread the properties from the form value
      dataCenter: this.dataCenter,      // Add the dataCenter
      websiteUrl: this.cloneWebsiteForm?.get('subdomain').value + '.' + this.configHostname,  // Add the selectedWebsite if needed
    };
    this.submitted.emit(emittedData);
  }

}
